/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import WhatsappIntegrationActions from '@Actions/integrations/whatsappIntegrationActions';
import H3FormInput from '@Uilib/h3FormInput';
import {
  Select, Table, notification,
} from 'antd';
import { CloseOutlined, PlusCircleFilled } from '@ant-design/icons';
import { CountryCodes } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import { v4 as uuidv4 } from 'uuid';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const AccountSetup = ({
  user, setStep, updateWhatsappConfiguration, getWhatsappConnections, getWhatsappConnectionsLoading, updateWhatsappConfigurationLoading,
}) => {
  const [formSubmitted, setFormSubmitted] = useState('');
  const [data, setData] = useState([]);

  function convertOldDataToRequiredData(dataInput) {
    const newData = [];

    // Create a map to store user data based on mobile number
    const userMap = new Map();

    // Iterate through the data array
    dataInput.forEach((item) => {
      const { org_id, tenant_id, pocs } = item;

      // Iterate through the pocs array
      pocs.forEach((poc) => {
        const {
          mobile, user_name, country_code, entity_name,
        } = poc;

        // Check if the user exists in the userMap
        if (userMap.has(mobile)) {
          // User already exists, update tenantIds
          const userData = userMap.get(mobile);
          userData.tenantIds.push(tenant_id);
        } else {
          // User doesn't exist, create a new user object
          const newUser = {
            mobile,
            userName: user_name,
            countryCode: country_code,
            userNumber: mobile,
            tenantIds: [tenant_id],
            entityNames: entity_name,
          };

          // Add the new user to the userMap
          userMap.set(mobile, newUser);
        }
      });
    });

    // Convert the userMap values to an array and push to newData
    userMap.forEach((userPOC) => {
      newData.push(userPOC);
    });

    return newData?.map((item) => ({ ...item, key: uuidv4() }));
  }

  useEffect(() => {
    getWhatsappConnections(user?.tenant_info?.org_id, (connections) => {
      const tenantIntegration = connections?.tenant_integrations;

      if (tenantIntegration?.length > 0) {
        setData(convertOldDataToRequiredData(tenantIntegration));
      } else {
        setData([
          {
            key: uuidv4(),
            userName: '',
            countryCode: Helpers.getDialCode(user?.tenant_info?.country_code),
            userNumber: '',
            entityNames: [],
            tenantIds: [],
          },
        ]);
      }
    });
  }, []);

  const entities = [
    {
      id: 1,
      name: 'Purchase Order',
      value: 'PURCHASE_ORDER',
    },
  ];

  const addNewRow = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    if (copyData?.length > 4) {
      notification.error({
        message: 'You may add upto 5 numbers to receive a notification.',
        placement: 'top',
        duration: 4,
      });
    } else {
      copyData.push({
        key: uuidv4(),
        userName: '',
        countryCode: Helpers.getDialCode(user?.tenant_info?.country_code),
        userNumber: '',
        entityNames: [],
        tenantIds: [],
      });
      setData(copyData);
    }
  };

  const handleDelete = (key) => {
    if (data?.length === 1) {
      setData([
        {
          key: uuidv4(),
          userName: '',
          countryCode: '',
          userNumber: '',
          tenantIds: [],
          entityNames: [],
        },
      ]);
    } else {
      const copyData = data.filter((item) => item.key !== key);
      setData(copyData);
    }
  };

  const countryCodeOptions = CountryCodes?.map((countryCode) => ({
    label: `${countryCode?.flag} +${countryCode?.dial_code}`,
    value: countryCode?.dial_code,
    key: countryCode?.name,
  }));

  const columns = [
    {
      title: 'NAME',
      width: '150px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div>
          <H3FormInput
            value={record?.userName}
            maxlength="50"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            placeholder="enter name.."
            inputClassName={(formSubmitted && !record?.userName) ? 'orgFormInputError' : 'orgFormInput'}
            onChange={(event) => {
              const copyData = JSON.parse(JSON.stringify(data));
              for (let i = 0; i < copyData?.length; i++) {
                if (copyData[i]?.key === record?.key) {
                  copyData[i].userName = event.target.value;
                }
              }
              setData(copyData);
            }}
            disabled={updateWhatsappConfigurationLoading}
          />
        </div>
      ),
    },
    {
      title: 'NUMBER',
      width: '200px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <PRZSelect
              value={record?.countryCode}
              showSearch
              filterOption={(input, option) => {
                const { label } = option.props;
                const { value } = option.props;
                return (
                  label.toLowerCase().includes(input.toLowerCase())
                 || value.toLowerCase().includes(input.toLowerCase())
                );
              }}
              onChange={(value) => {
                const copyData = JSON.parse(JSON.stringify(data));
                for (let i = 0; i < copyData?.length; i++) {
                  if (copyData[i]?.key === record?.key) {
                    copyData[i].countryCode = value;
                  }
                }
                setData(copyData);
              }}
              style={{
                border: !(formSubmitted && !record?.countryCode)
                  ? '1px solid rgba(68, 130, 218, 0.2)'
                  : '1px solid red',
              }}
              disabled={updateWhatsappConfigurationLoading}
              options={countryCodeOptions}
              placeholder=""
            />
          </div>
          <H3FormInput
            value={record?.userNumber}
            maxlength="10"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            placeholder="enter phone.."
            inputClassName={(formSubmitted && (!record?.userNumber || record?.userNumber?.length !== 10)) ? 'orgFormInputError' : 'orgFormInput'}
            onChange={(event) => {
              const copyData = JSON.parse(JSON.stringify(data));
              for (let i = 0; i < copyData?.length; i++) {
                if (copyData[i]?.key === record?.key) {
                  copyData[i].userNumber = event.target.value;
                }
              }
              setData(copyData);
            }}
            disabled={updateWhatsappConfigurationLoading}
          />
        </div>
      ),
    },
    {
      title: 'BUSINESS UNITS',
      width: '200px',
      render: (record) => (
        <div>
          <TenantSelector
            selectedTenant={record?.tenantIds}
            noDropdownAlign
            showSearch
            onChange={(value) => {
              const copyData = JSON.parse(JSON.stringify(data));
              for (let i = 0; i < copyData?.length; i++) {
                if (copyData[i]?.key === record?.key) {
                  copyData[i].tenantIds = value;
                }
              }
              setData(copyData);
            }}
            hideTitle
            customStyle={{
              border: (formSubmitted && record?.tenantIds?.length === 0)
                ? '1px solid red'
                : 'none',
              borderRadius: '2px',
              height: '28px',
              width: '100%',
              fontSize: '13px',
            }}
            containerClassName="create-price-list__input-row__input"
            placeholder="Select Business Unit"
            isMultiple
            disabled={updateWhatsappConfigurationLoading}
          />
        </div>
      ),
    },
    {
      title: '',
      render: (text, record) => (
        <Fragment>
          {data.length !== record.key && (
            <div className="whatsapp__poc-delete-button" onClick={() => handleDelete(record.key)}>
              <CloseOutlined />
            </div>
          )}
        </Fragment>
      ),
      width: '40px',
      fixed: 'right',
    },
  ];

  const getDataSource = () => {
    const copyData = JSON.parse(JSON.stringify(data));

    return copyData;
  };

  function convertDataToNewData(inputData) {
    const newData = [];

    inputData?.forEach((item) => {
      item?.tenantIds?.forEach((tenantId) => {
        const existingEntry = newData?.find((entry) => entry?.tenant_id === tenantId);

        if (existingEntry) {
          existingEntry.pocs.push({
            mobile: item?.userNumber,
            country_code: item?.countryCode,
            user_name: item?.userName,
            entity_name: item?.entityNames,
          });
        } else {
          newData.push({
            org_id: user?.tenant_info?.org_id,
            pocs: [
              {
                mobile: item?.userNumber,
                country_code: item?.countryCode,
                user_name: item?.userName,
                entity_name: item?.entityNames,
              },
            ],
            tenant_id: tenantId,
          });
        }
      });
    });

    return newData;
  }

  const isDataValid = () => {
    let isValid = true;

    for (let i = 0; i < data?.length; i++) {
      const checkData = data[i];
      if (!checkData?.userName || !checkData?.countryCode || !checkData?.userNumber || checkData?.userNumber?.length !== 10 || checkData?.tenantIds?.length === 0 || checkData?.entityNames?.length === 0) {
        isValid = false;
      }
    }

    return isValid;
  };

  const handleSubmit = () => {
    setFormSubmitted(true);

    if (isDataValid()) {
      const payload = convertDataToNewData(data);

      updateWhatsappConfiguration(payload, () => {
        setStep(2);
      });
    }
  };

  return (
    <Fragment>
      {(getWhatsappConnectionsLoading)
        ? (
          <div className="whatsapp-integration__loader__wrapper">

            { [...Array(5).keys()].map((item) => (
              <div key={item} className="whatsapp-integration__loader-row">
                <div className="loadingBlock  whatsapp-integration__loader__line1" />
                <div className="loadingBlock  whatsapp-integration__loader__line2" />
                <div className="loadingBlock  whatsapp-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock whatsapp-integration__loader__line-btn1" />
            <div className="loadingBlock whatsapp-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="whatsapp__poc-wrapper">

            <div className="whatsapp__poc-header-wrapper">
              Add upto 5 team members to receive whatsapp notifications.
              You can add more recipients later from business profile tab.
            </div>

            <div className="whatsapp__poc-body-wrapper">
              <div className="ant-row">
                <div className="ant-col-md-24">
                  <Table
                    columns={columns}
                    loading={getWhatsappConnectionsLoading || updateWhatsappConfigurationLoading}
                    dataSource={getDataSource(data) || []}
                    size="small"
                    pagination={false}
                  />
                </div>
              </div>
              <div className="ant-row">
                <div className="ant-col-md-12">
                  <div
                    className="new-row-button"
                    onClick={() => addNewRow()}
                  >
                    <span className="new-row-button__icon">
                      <PlusCircleFilled />
                    </span>
                    <div>New Item</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="whatsapp__poc-footer-wrapper">
              <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
                <div>
                  <H3Button
                    text="Save and Continue"
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    onClick={() => handleSubmit()}
                    customClass="whatsapp__account-submit"
                    isLoading={updateWhatsappConfigurationLoading}
                    disabled={updateWhatsappConfigurationLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, WhatsappIntegrationReducers }) => ({
  user: UserReducers.user,
  getWhatsappConnectionsLoading: WhatsappIntegrationReducers.getWhatsappConnectionsLoading,
  updateWhatsappConfigurationLoading: WhatsappIntegrationReducers.updateWhatsappConfigurationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateWhatsappConfiguration: (payload, callback) => dispatch(WhatsappIntegrationActions.updateWhatsappConfiguration(payload, callback)),
  getWhatsappConnections: (orgId, callback) => dispatch(WhatsappIntegrationActions.getWhatsappConnections(orgId, callback)),
});

AccountSetup.propTypes = {
  user: PropTypes.any,
  setStep: PropTypes.func,
  updateWhatsappConfiguration: PropTypes.func,
  getWhatsappConnections: PropTypes.func,
  getWhatsappConnectionsLoading: PropTypes.bool,
  updateWhatsappConfigurationLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountSetup));
